import { IconWrapper } from "@caprikorn/dynamo-ui";
import type { FC } from "react";

import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import classes from "./ErrorTemplate.module.css";
import type { ErrorTemplateProps } from "./ErrorTemplate.types";

export const ErrorTemplate: FC<ErrorTemplateProps> = ({
  title,
  text,
  children,
  "data-testid": dataTestId,
  imageType = "notFound",
}) => {
  const { t } = useCustomTranslation("common");

  return (
    <div className={classes.container} data-testid={dataTestId}>
      <IconWrapper role="presentation" size="4xl" src={imageType} />
      <h3 className="font-title-md">{title ?? t("errors.title.small")}</h3>
      {text && <div className="font-paragraph-accent">{text}</div>}
      {children}
    </div>
  );
};
